<template>  
  <div>
    <q-card inline style="width: 300px">
      <q-card-main>
        <div> 
          <div class="row">
            <div class="col-12">
            <q-btn class="space float-right" color="primary" :label="newTitle" size="sm" @click="addDialog = true" />
            </div>
            <div class="col-12">            
              <q-table
                :title="title"
                :data="dataRows"
                :columns="columnsEvent"
                row-key="value"
                :dense=true
                selection="single"
                :selected.sync="selectedDataRows"
                :pagination.sync="pagination" 
                >
                <q-td slot="body-cell-Thumbnail" slot-scope="props" :props="props">
                  <img :src="'data:image/png;base64,' + props.value" @click="showPic(props.row.IdEvent)">
                </q-td>
              <template slot="top-selection" slot-scope="props" >
                <div class="q-table-title">{{title}}</div>
                <div>
                  <q-btn color="secondary" flat :label="$t('global.Edit')" @click="editGroup()" />  
                  <q-btn color="secondary" flat :label="$t('global.Delete')" @click="deleteEntity()" v-if="selectedDataRows[0].CanDelete == true" />
                </div>
              </template>
              </q-table>
            </div>
          </div>  
          <br>
        </div>
        
        
        <q-dialog
          v-model="editDialog"
          prevent-close
          
        >
          <!-- This or use "title" prop on <q-dialog> -->
          <span slot="title">{{title}}</span>
          <div slot="body" class="dialog">
              <q-input v-model="editName" ref="editName" float-label="Name"/>
              <div v-if="Entity.entity == 'ResourceTemplate' && selectedDataRows[0]">                
                <q-input class="content" v-model="Number1" :stack-label="$t('global.CostHour')" type="number" :decimals="2" />
                <br>
                <div class="row">
                  <div class="col-4">
                   <strong> {{$t('global.PerAssignment')}}</strong>
                  </div>
                  <div class="col-8">
                  <q-checkbox v-model="flexCost"   :label="$t('global.ResourceCostFlexible')" />
                  </div>
                </div>
                <br>
                <div class="row" v-if="flexCost == false">
                  <div class="col-5">
                    <q-input class="content" v-model="Number2" :stack-label="$t('global.CostFix')" type="number" :decimals="2" />
                  </div>
                  &nbsp;
                  <div class="col-5">
                    <q-input class="content" v-model="Number3" :stack-label="$t('global.CostHa')" type="number" :decimals="2" />
                  </div>
                </div>
              </div>
          </div>
          

          <template slot="buttons" slot-scope="props">
            <q-btn color="primary" :label="$t('global.Save')" @click="updateDelay()" />
            <q-btn flat :label="$t('global.Cancel')" @click="props.cancel" />
          </template>
        </q-dialog>


        <q-dialog
          class="dia"
          v-model="addDialog"
          prevent-close
          >
          <span slot="title">{{newTitle}}</span>
          <div slot="body" class="dialog">
              <q-input v-model="newEntity" float-label="Name"/>
              <div v-if="Entity.entity == 'ResourceTemplate'">   
                <q-input class="content" v-model="Number1" :stack-label="$t('global.CostHour')" type="number" :decimals="2" />
                 <br>
                <div class="row">
                  <div class="col-4">
                   <strong> {{$t('global.PerAssignment')}}</strong>
                  </div>
                  <div class="col-8">
                  <q-checkbox v-model="flexCost" :label="$t('global.ResourceCostFlexible')" />
                  </div>
                </div>
                <div class="row" v-if="flexCost == false">
                  <div class="col-5">
                    <q-input class="content" v-model="Number3" :stack-label="$t('global.CostFix')" type="number" :decimals="2" />
                  </div>
                  &nbsp;
                  <div class col-5>
                    <q-input class="content" v-model="Number2" :stack-label="$t('global.CostHa')" type="number" :decimals="2" />
                  </div> 
                </div> 
               
              </div>
          </div>
          <template slot="buttons" slot-scope="props">
           <div class="row">
              <div class="col-6">
                <q-btn color="primary" :label="$t('global.Save')" @click="saveEntity()" :disable="newEntity == '' "/>
              </div>
              <div class="col-6">
                <q-btn flat :label="$t('global.Cancel')" @click="props.cancel" />
              </div>
           </div>
          </template>
        </q-dialog>
      </q-card-main>
    </q-card>   
  </div>
</template>

<script>
import { date } from 'quasar'
import {eventBus} from '../main'
import axios from 'axios'
import qs from 'qs'

export default {
  data () {
    return {
      form: {
        SessionId: null,
      },
      IdCostType: '2',
      newEntity: '',
      dataRows: [],
      maintenanceGroupSelected: null,
      title: 'General Editor',
      newTitle: 'General New',
      newOpend: false,
      selectedDataRows: [],
      columnsEvent: [
        {
          name: 'product',required: true, align: 'left',
          field: 'label',sortable: true
        }],
       pagination: {
        sortBy: null, // String, column "name" property value
        descending: false,
        page: 1,
        rowsPerPage: 10 // current rows per page being displayed
      },
      editDialog: false,
      addDialog: false,
      editName: '',
      Number1: null,
      Number2: null,
      Number3: '',  
      flexCost: false
    }
  },
  props: ['Entity'],
  methods: {
    loadData(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "getEntity"
      this.form.Entity = this.Entity.entity
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              this.dataRows = response.data
          }
          else{
              this.$q.notify(this.$t('global.SomethingWrong'))
          }
      })
      .catch(e => {
        this.$q.notify(this.$t('global.SomethingWrong'))
        console.log(e);
      })
    },
    
    Init(){ 
      this.dataRows = []
      if(this.Entity.entity == 'Product'){
        this.title = this.$t('global.Product')
        this.newTitle = this.$t('global.NewProduct')
        this.loadData()
      }
      if(this.Entity.entity == 'EventType'){
        this.title = this.$t('global.EventType')
        this.newTitle = this.$t('global.NewEventType')
        this.loadData()
      }
      if(this.Entity.entity == 'ResourceTemplate'){
        this.title = this.$t('global.ResourceTemlate')
        this.newTitle = this.$t('global.NewResourceTemlate')
        this.loadData()
      }
    },
    editGroup(){
      this.editName  = this.selectedDataRows[0].label
      this.Number1 = this.selectedDataRows[0].Number1
      this.Number2 = this.selectedDataRows[0].Number2
      this.Number3 = this.selectedDataRows[0].Number3
      this.IdCostType = String(this.selectedDataRows[0].IdCostType)
      this.flexCost = this.selectedDataRows[0].ResourceCostFlexible
      this.editDialog = true
    },
    updateDelay(){
      setTimeout(()=>{ this.updateEvent() }, 200)
    },
    updateEvent(){
      this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "updateEntity"
        this.form.Entity = this.Entity.entity
        this.form.Id = this.selectedDataRows[0].value
        this.form.Description = this.editName
        if(this.Entity.entity == 'ResourceTemplate'){
          this.form.Number1 = this.Number1
          this.form.Number2 = this.Number2
          this.form.Number3 = this.Number3
          this.form.IdCostType = this.IdCostType
          this.form.ResourceCostFlexible = this.flexCost
        }
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            this.submitting = false
            if(response.status == 200){ 
              if(response.data == "OK"){
                this.$q.notify({ message: this.$t('global.WorkChanged'), type: 'positive' })
                this.selectedDataRows = []
                this.loadData()
                this.editDialog = false
                eventBus.$emit('dataChange', null)
              }
              else{
                this.$q.notify(this.$t('global.SomethingWrong'))
              }
            }
            else{
                this.$q.notify(this.$t('global.SomethingWrong'))
            }
        })
        .catch(e => {
          this.$q.notify(this.$t('global.SomethingWrong'))
          console.log(e);
        })
    },
    deleteEntity(){
      var self = this
      this.$q.dialog({
        title: this.selectedDataRows[0].label,
        message: this.title + ' ' + this.$t('global.Delete') + '?',
        color: 'primary',
        ok: true, 
        cancel: true, 
        preventClose: true,
        noBackdropDismiss: false, 
        noEscDismiss: false, 
        stackButtons: false,
        position: 'top',     
         
      })
      .then(() => {
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "deleteEntity"
        this.form.Entity = this.Entity.entity
        this.form.Id = this.selectedDataRows[0].value
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            this.submitting = false
            if(response.status == 200){ 
              if(response.data == "OK"){
                this.$q.notify({ message: this.$t('global.EntryDeleted'), type: 'positive' })
                this.loadData()
                this.selectedDataRows = []
                eventBus.$emit('dataChange', null)
              }
              else{
                this.$q.notify(this.$t('global.SomethingWrong'))
              }
            }
            else{
                this.$q.notify(this.$t('global.SomethingWrong'))
            }
        })
        .catch(e => {
          this.$q.notify(this.$t('global.SomethingWrong'))
          console.log(e);
        })
      })
      .catch(() => {
        //alert('Picked cancel')
      })
    },
    saveEntity(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "insertEntity"
      this.form.Entity = this.Entity.entity
      this.form.Description = this.newEntity
      if(this.Entity.entity == 'ResourceTemplate'){
        this.form.Number1 = this.Number1
        this.form.Number2 = this.Number2
        this.form.Number3 = this.Number3
        this.form.IdCostType = Number(this.IdCostType)
        this.form.ResourceCostFlexible = this.flexCost
      }

      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              if(response.data == "OK"){
                this.$q.notify({ message: this.$t('global.NewEntry'), type: 'positive' })
                this.addDialog = false
                this.newEntity = ''
                this.loadData()
                eventBus.$emit('dataChange', null)
              }
              else{
                  this.$q.notify(this.$t('global.SomethingWrong'))
              }
          }
          else{
              this.$q.notify(this.$t('global.SomethingWrong'))
          }
      })
      .catch(e => {
        this.$q.notify(this.$t('global.SomethingWrong'))
        console.log(e);
      })
      
    },
    

  },
  created () {
    this.Init()
    eventBus.$on('Bus_ChangeLocale', (data) => {
      this.Init()
    })
  },
   watch: {
    Entity: function (newValue, oldValue) { 
      this.Init()
    },
   },
  
}

function error(err) {
  console.log(`ERROR(${err.code}): ${err.message}`);
}

</script>

<style scoped>
 .space{
    margin-bottom: 10px;
  } 
  .dialog{
    width: 360px;
  }
  
</style>